// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"789bcf63","318":"3db20a86","333":"5da9d55c","522":"7d6cb23d","559":"d766fa9c","743":"6d7e483f"}[chunkId] + ".chunk.js";
};